import ruLocale from "date-fns/locale/ru";
import get from "lodash/get";
import React, { FC } from "react";
import { Button } from "@pd/pd-ui-kit";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import Preloader from "~/components/Preloader";
import { getIndicatorValue } from "~/libs/getData";
import { getIndicatorPeriod } from "~/libs/getFormatDate";
import { showDate } from "~/pages/Q/formater";
import {
  useGetQDetailingMainIndicatorQuery,
  useGetQReportDetailingMainIndicatorLazyQuery,
} from "~/schemas/generated/graphql";
import { usePermissions } from "~/shared/context/PermissionContext";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";
import { useNotify } from "~/shared/hooks/useNotify";
import { TableV2 } from "~/shared/ui/TableV2";

import { Q_VIEW_OPTIONS } from "./options";

import s from "./QView.less";

interface IProps {
  onSet?: () => void;
  currentDate?;
}

const QView: FC<IProps> = ({ currentDate }) => {
  const { t } = useTranslation();
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const lang = localStorage.getItem("language");
  const currentDealerId = useCurrentDealerId();
  const noCaching = sessionStorage.getItem("noCaching");
  const { notifyReport } = useNotify();
  const [
    getQReportDetailingMainIndicatorLazyQuery,
    QReportDetailingMainIndicatorLazyQuery,
  ] = useGetQReportDetailingMainIndicatorLazyQuery({
    onCompleted(data) {
      const hash = get(
        data,
        "QuartilesRatingGetter.getReportDetailingMainIndicator.fileHash",
      );
      hash && notifyReport(hash);
    },
    fetchPolicy: "no-cache",
  });

  const { data, loading } = useGetQDetailingMainIndicatorQuery({
    variables: {
      DealerId: currentDealerId,
      date: currentDate,
    },
    fetchPolicy: noCaching ? "no-cache" : "cache-first",
  });

  const { Indicator = {}, IndicatorGroup = {} } = get(
    data,
    "QuartilesRatingGetter.getDetailingMainIndicator",
    {},
  );

  const { Values = [], period = "" } = Indicator;
  const qs = Values.map((value) => getIndicatorPeriod(value, period))
    .filter((ind, index, arr) => arr.indexOf(ind) === index)
    .map((indicatorPeriod) => {
      const getCurrentValue = (indicator) => {
        const values = indicator.Values.filter(
          (value) => getIndicatorPeriod(value, period) === indicatorPeriod,
        );
        const indValue = values.length > 0 && values[0].stringValue;
        return getIndicatorValue(indicator, null, null, indValue);
      };

      return {
        LastPeriodIndicatorId: format(new Date(indicatorPeriod), "MMM yyyy", {
          locale: ruLocale,
        }),
        place: getCurrentValue(Indicator),
        GroupIndicatorId: getCurrentValue(IndicatorGroup),
      };
    });
  const getQReportDetailingMainIndicator = () => {
    getQReportDetailingMainIndicatorLazyQuery({
      variables: {
        DealerId: currentDealerId,
        date: currentDate,
        lang,
      },
    });
  };

  return (
    <div className={s.q_view_wrapper}>
      <header className={s.s_header}>
        <label className={s.s_title}>
          {`${t("q.quartiles")} ${t("ui.from&")} ${showDate(currentDate)}`}
        </label>
        {hasPermission("quartilesRatings.reportDetailingMainIndicator.get") && (
          <Button
            size={"middle"}
            color={"success"}
            customClassName={s.btn_end}
            onClick={getQReportDetailingMainIndicator}
            loading={QReportDetailingMainIndicatorLazyQuery.loading}
          >
            {t("q.save_excel")}
          </Button>
        )}
      </header>

      {loading ? (
        <Preloader />
      ) : (
        <TableV2
          dataSource={qs}
          options={Q_VIEW_OPTIONS}
          loading={loading}
          type="q"
          wrapperClassName={s.q_view_table}
        />
      )}
    </div>
  );
};
export default QView;
